import React, { useState, useEffect } from 'react';
import api from '../../utils/api';
import { toast } from 'react-toastify';
import { FiMessageSquare, FiSend, FiImage, FiMail, FiPhone, FiFileText, FiLink, FiType, FiVideo, FiFile, FiBell, FiPhoneCall, FiSettings, FiPlus, FiTrash2 } from 'react-icons/fi';

const TYPE_CONFIG = {
  sms: {
    label: 'SMS',
    icon: <FiPhone />,
    color: '#00B4D8',
    gradient: 'linear-gradient(135deg, #00B4D8 0%, #5c7a1f 100%)',
    fields: ['senderId', 'messageContent', 'footerText'],
    senderLabel: 'Sender ID',
    senderPlaceholder: 'e.g. MYBRAND',
    messagePlaceholder: 'Type your SMS message here... (160 chars recommended)',
    maxChars: 480,
    preview: 'sms'
  },
  whatsapp: {
    label: 'WhatsApp',
    icon: <FiMessageSquare />,
    color: '#22c55e',
    gradient: 'linear-gradient(135deg, #22c55e 0%, #16a34a 100%)',
    fields: ['senderId', 'templateName', 'headerText', 'messageContent', 'footerText', 'buttonText', 'buttonUrl'],
    senderLabel: 'WhatsApp Business Number',
    senderPlaceholder: 'e.g. +91 98765 43210',
    messagePlaceholder: 'Enter your WhatsApp message template body...',
    maxChars: 4096,
    preview: 'whatsapp'
  },
  whatsapp_image: {
    label: 'WhatsApp Image',
    icon: <FiImage />,
    color: '#0891b2',
    gradient: 'linear-gradient(135deg, #0891b2 0%, #0e7490 100%)',
    fields: ['senderId', 'templateName', 'imageUrl', 'messageContent', 'footerText', 'buttonText', 'buttonUrl'],
    senderLabel: 'WhatsApp Business Number',
    senderPlaceholder: 'e.g. +91 98765 43210',
    messagePlaceholder: 'Image caption text...',
    maxChars: 1024,
    preview: 'whatsapp_image'
  },
  whatsapp_video: {
    label: 'WhatsApp Video',
    icon: <FiVideo />,
    color: '#0d9488',
    gradient: 'linear-gradient(135deg, #0d9488 0%, #0f766e 100%)',
    fields: ['senderId', 'templateName', 'videoUrl', 'messageContent', 'footerText', 'buttonText', 'buttonUrl'],
    senderLabel: 'WhatsApp Business Number',
    senderPlaceholder: 'e.g. +91 98765 43210',
    messagePlaceholder: 'Video caption text...',
    maxChars: 1024,
    preview: 'whatsapp_video'
  },
  whatsapp_document: {
    label: 'WhatsApp Document',
    icon: <FiFile />,
    color: '#059669',
    gradient: 'linear-gradient(135deg, #059669 0%, #047857 100%)',
    fields: ['senderId', 'templateName', 'documentUrl', 'documentName', 'messageContent', 'footerText', 'buttonText', 'buttonUrl'],
    senderLabel: 'WhatsApp Business Number',
    senderPlaceholder: 'e.g. +91 98765 43210',
    messagePlaceholder: 'Document message text...',
    maxChars: 1024,
    preview: 'whatsapp_document'
  },
  rcs: {
    label: 'RCS Message',
    icon: <FiMessageSquare />,
    color: '#00B4D8',
    gradient: 'linear-gradient(135deg, #00B4D8 0%, #0096C7 100%)',
    fields: ['senderId', 'headerText', 'imageUrl', 'messageContent', 'footerText', 'buttonText', 'buttonUrl'],
    senderLabel: 'RCS Agent / Brand',
    senderPlaceholder: 'e.g. MyBrand RCS',
    messagePlaceholder: 'Enter RCS rich message content...',
    maxChars: 4096,
    preview: 'rcs'
  },
  status_messaging: {
    label: 'Status Message',
    icon: <FiSend />,
    color: '#f97316',
    gradient: 'linear-gradient(135deg, #f97316 0%, #ea580c 100%)',
    fields: ['senderId', 'templateName', 'messageContent', 'footerText'],
    senderLabel: 'Sender ID',
    senderPlaceholder: 'e.g. ALERTS',
    messagePlaceholder: 'Enter status/transactional message content...',
    maxChars: 2048,
    preview: 'status'
  },
  newsletter: {
    label: 'Newsletter',
    icon: <FiMail />,
    color: '#ef4444',
    gradient: 'linear-gradient(135deg, #ef4444 0%, #dc2626 100%)',
    fields: ['senderId', 'subject', 'headerText', 'imageUrl', 'messageContent', 'footerText', 'buttonText', 'buttonUrl'],
    senderLabel: 'From Email / Sender',
    senderPlaceholder: 'e.g. newsletter@mybrand.com',
    messagePlaceholder: 'Enter newsletter body content...',
    maxChars: 10000,
    preview: 'newsletter'
  },
  emailer: {
    label: 'Emailer',
    icon: <FiMail />,
    color: '#d97706',
    gradient: 'linear-gradient(135deg, #d97706 0%, #b45309 100%)',
    fields: ['senderId', 'subject', 'headerText', 'imageUrl', 'messageContent', 'footerText', 'buttonText', 'buttonUrl'],
    senderLabel: 'From Email / Sender',
    senderPlaceholder: 'e.g. campaign@mybrand.com',
    messagePlaceholder: 'Enter emailer body content...',
    maxChars: 10000,
    preview: 'newsletter'
  },
  push_notification: {
    label: 'Push Notification',
    icon: <FiBell />,
    color: '#1a1a18',
    gradient: 'linear-gradient(135deg, #1a1a18 0%, #2d2d28 100%)',
    fields: ['senderId', 'notificationTitle', 'messageContent', 'imageUrl', 'buttonText', 'buttonUrl'],
    senderLabel: 'App Name',
    senderPlaceholder: 'e.g. MyApp',
    messagePlaceholder: 'Notification body text...',
    maxChars: 256,
    preview: 'push_notification'
  },
  voice_call: {
    label: 'Voice Call',
    icon: <FiPhoneCall />,
    color: '#00BFA5',
    gradient: 'linear-gradient(135deg, #00BFA5 0%, #00897B 100%)',
    fields: ['senderId', 'voiceScript', 'footerText'],
    senderLabel: 'Caller ID / DID Number',
    senderPlaceholder: 'e.g. +91 1800 XXX XXXX',
    messagePlaceholder: 'Voice call script...',
    maxChars: 5000,
    preview: 'voice_call'
  },
  custom: {
    label: 'Custom',
    icon: <FiSettings />,
    color: '#546E7A',
    gradient: 'linear-gradient(135deg, #546E7A 0%, #37474F 100%)',
    fields: ['senderId', 'templateName', 'subject', 'headerText', 'messageContent', 'footerText', 'imageUrl', 'buttonText', 'buttonUrl', 'customFields'],
    senderLabel: 'Sender / Source',
    senderPlaceholder: 'e.g. Your sender ID',
    messagePlaceholder: 'Enter your message content...',
    maxChars: 10000,
    preview: 'custom'
  }
};

const defaultForm = {
  campaignId: '', senderId: '', messageContent: '', totalDeliveries: '',
  subject: '', headerText: '', footerText: '', buttonText: '', buttonUrl: '',
  imageUrl: '', templateName: '', ctaType: '',
  videoUrl: '', documentUrl: '', documentName: '',
  notificationTitle: '', voiceScript: '',
  customFields: {}
};

export default function ScheduleManagement() {
  const [grouped, setGrouped] = useState([]);
  const [campaigns, setCampaigns] = useState([]);
  const [showCreate, setShowCreate] = useState(false);
  const [showEdit, setShowEdit] = useState(null);
  const [showPreview, setShowPreview] = useState(null);
  const [loading, setLoading] = useState(true);
  const [form, setForm] = useState({ ...defaultForm });
  const [editForm, setEditForm] = useState({ ...defaultForm });
  const [editingDate, setEditingDate] = useState(null); // { batchId, value, field }

  const fetchSchedules = async () => {
    setLoading(true);
    try {
      const { data } = await api.get('/admin/schedules');
      setGrouped(data.grouped || []);
    } catch { toast.error('Failed to load schedules'); }
    finally { setLoading(false); }
  };

  useEffect(() => {
    fetchSchedules();
    api.get('/admin/campaigns/with-data').then(({ data }) => setCampaigns(data.campaigns || [])).catch(() => {});
  }, []);

  const selectedCampaign = campaigns.find(c => c._id === form.campaignId);
  const campaignType = selectedCampaign?.type || '';
  const typeConfig = TYPE_CONFIG[campaignType] || null;

  const editCampaignType = showEdit?.campaignId?.type || '';
  const editTypeConfig = TYPE_CONFIG[editCampaignType] || null;

  const handleCreate = async (e) => {
    e.preventDefault();
    try {
      await api.post('/admin/schedules', { ...form, totalDeliveries: parseInt(form.totalDeliveries) || 1 });
      toast.success('Schedule created');
      setShowCreate(false);
      setForm({ ...defaultForm });
      fetchSchedules();
    } catch (err) { toast.error(err.response?.data?.message || 'Error'); }
  };

  const handleEdit = async (e) => {
    e.preventDefault();
    try {
      await api.put(`/admin/schedules/${showEdit._id}`, editForm);
      toast.success('Schedule updated');
      setShowEdit(null);
      fetchSchedules();
    } catch (err) { toast.error(err.response?.data?.message || 'Error'); }
  };

  const handleDelete = async (id) => {
    if (!window.confirm('Delete this schedule and all batches?')) return;
    try { await api.delete(`/admin/schedules/${id}`); toast.success('Deleted'); fetchSchedules(); }
    catch { toast.error('Failed'); }
  };

  const handleBatchStatus = async (batchId, status) => {
    try {
      await api.patch(`/admin/schedules/batch/${batchId}/status`, { status });
      toast.success(`Batch ${status}`);
      fetchSchedules();
    } catch (err) { toast.error(err.response?.data?.message || 'Failed'); }
  };

  const handleBatchDateUpdate = async (batchId) => {
    if (!editingDate || editingDate.batchId !== batchId) return;
    try {
      const payload = {};
      payload[editingDate.field] = editingDate.value;
      await api.patch(`/admin/schedules/batch/${batchId}/status`, payload);
      toast.success(`${editingDate.field === 'sentAt' ? 'Sent' : 'Schedule'} date updated`);
      setEditingDate(null);
      fetchSchedules();
    } catch (err) { toast.error(err.response?.data?.message || 'Failed to update date'); }
  };

  // ── MESSAGE PREVIEW RENDERERS ──
  const renderMessagePreview = (type, data) => {
    const cfg = TYPE_CONFIG[type];
    if (!cfg) return null;

    if (type === 'sms') {
      return (
        <div style={{ background: '#f4f4f4', borderRadius: 16, padding: 16, maxWidth: 300, fontFamily: '-apple-system, sans-serif' }}>
          <div style={{ background: '#fff', borderRadius: 12, padding: 14, boxShadow: '0 1px 3px rgba(0,0,0,0.1)' }}>
            <div style={{ fontSize: 11, color: '#888', marginBottom: 6, fontWeight: 600 }}>{data.senderId || 'SENDER'}</div>
            <div style={{ fontSize: 14, color: '#222', lineHeight: 1.5, whiteSpace: 'pre-wrap' }}>{data.messageContent || 'Message content...'}</div>
            {data.footerText && <div style={{ fontSize: 11, color: '#999', marginTop: 8, borderTop: '1px solid #eee', paddingTop: 6 }}>{data.footerText}</div>}
            <div style={{ fontSize: 10, color: '#bbb', marginTop: 8, textAlign: 'right' }}>{new Date().toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })}</div>
          </div>
        </div>
      );
    }

    if (type === 'whatsapp' || type === 'whatsapp_image') {
      return (
        <div style={{ background: '#e5ddd5', borderRadius: 12, padding: 16, maxWidth: 340 }}>
          <div style={{ background: '#dcf8c6', borderRadius: '0 12px 12px 12px', padding: 0, maxWidth: 300, overflow: 'hidden', boxShadow: '0 1px 2px rgba(0,0,0,0.15)' }}>
            {data.headerText && (
              <div style={{ padding: '10px 14px 4px', fontSize: 13, fontWeight: 700, color: '#222' }}>{data.headerText}</div>
            )}
            {type === 'whatsapp_image' && (
              <div style={{ background: '#c8e6c9', height: 160, display: 'flex', alignItems: 'center', justifyContent: 'center', margin: data.headerText ? '0 8px' : 0, borderRadius: data.headerText ? 8 : 0 }}>
                {data.imageUrl ? (
                  <img src={data.imageUrl} alt="preview" style={{ width: '100%', height: 160, objectFit: 'cover', borderRadius: data.headerText ? 8 : 0 }} onError={e => { e.target.style.display = 'none'; }} />
                ) : (
                  <FiImage style={{ fontSize: 40, color: '#69a36f' }} />
                )}
              </div>
            )}
            <div style={{ padding: '8px 14px', fontSize: 14, color: '#222', lineHeight: 1.5, whiteSpace: 'pre-wrap' }}>
              {data.messageContent || 'Message...'}
            </div>
            {data.footerText && <div style={{ padding: '0 14px 6px', fontSize: 11, color: '#888' }}>{data.footerText}</div>}
            <div style={{ padding: '0 14px 8px', textAlign: 'right' }}>
              <span style={{ fontSize: 10, color: '#7d9b7e' }}>{new Date().toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })}</span>
              <span style={{ fontSize: 10, color: '#4fc3f7', marginLeft: 4 }}>✓✓</span>
            </div>
            {data.buttonText && (
              <div style={{ borderTop: '1px solid #b6dab8', padding: '10px 14px', textAlign: 'center' }}>
                <span style={{ color: '#039be5', fontSize: 14, fontWeight: 500 }}>🔗 {data.buttonText}</span>
              </div>
            )}
          </div>
          {data.templateName && <div style={{ fontSize: 10, color: '#666', marginTop: 6, textAlign: 'center' }}>Template: {data.templateName}</div>}
        </div>
      );
    }

    if (type === 'status_messaging') {
      return (
        <div style={{ background: '#fff3e0', borderRadius: 12, padding: 16, maxWidth: 320, border: '1px solid #ffe0b2' }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: 8, marginBottom: 10 }}>
            <div style={{ width: 32, height: 32, borderRadius: '50%', background: '#f97316', display: 'flex', alignItems: 'center', justifyContent: 'center', color: '#fff', fontSize: 14, fontWeight: 700 }}>!</div>
            <div>
              <div style={{ fontSize: 12, fontWeight: 700, color: '#e65100' }}>{data.senderId || 'STATUS'}</div>
              {data.templateName && <div style={{ fontSize: 10, color: '#bf360c' }}>Template: {data.templateName}</div>}
            </div>
          </div>
          <div style={{ background: '#fff', borderRadius: 8, padding: 12, fontSize: 14, color: '#333', lineHeight: 1.5, whiteSpace: 'pre-wrap' }}>
            {data.messageContent || 'Status message...'}
          </div>
          {data.footerText && <div style={{ fontSize: 11, color: '#999', marginTop: 8 }}>{data.footerText}</div>}
        </div>
      );
    }

    if (type === 'newsletter' || type === 'emailer') {
      return (
        <div style={{ background: '#f5f5f5', borderRadius: 12, padding: 16, maxWidth: 380 }}>
          <div style={{ background: '#fff', borderRadius: 12, overflow: 'hidden', boxShadow: '0 2px 8px rgba(0,0,0,0.08)' }}>
            <div style={{ background: cfg.gradient, padding: '20px 20px 16px', color: '#fff' }}>
              <div style={{ fontSize: 11, opacity: 0.8 }}>From: {data.senderId || 'sender@brand.com'}</div>
              <div style={{ fontSize: 18, fontWeight: 700, marginTop: 6 }}>{data.subject || 'Newsletter Subject'}</div>
            </div>
            {data.headerText && <div style={{ padding: '14px 20px 0', fontSize: 13, fontWeight: 600, color: '#333' }}>{data.headerText}</div>}
            {data.imageUrl && (
              <div style={{ padding: '10px 20px 0' }}>
                <div style={{ background: '#e0e0e0', height: 140, borderRadius: 8, overflow: 'hidden', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                  <img src={data.imageUrl} alt="" style={{ width: '100%', height: 140, objectFit: 'cover' }} onError={e => { e.target.style.display = 'none'; }} />
                </div>
              </div>
            )}
            <div style={{ padding: '12px 20px', fontSize: 14, color: '#444', lineHeight: 1.6, whiteSpace: 'pre-wrap' }}>
              {data.messageContent || 'Newsletter content...'}
            </div>
            {data.buttonText && (
              <div style={{ padding: '0 20px 16px', textAlign: 'center' }}>
                <span style={{ display: 'inline-block', background: cfg.gradient, color: '#fff', padding: '10px 28px', borderRadius: 24, fontSize: 14, fontWeight: 600 }}>
                  {data.buttonText}
                </span>
              </div>
            )}
            {data.footerText && (
              <div style={{ padding: '12px 20px', borderTop: '1px solid #eee', fontSize: 11, color: '#999', textAlign: 'center' }}>
                {data.footerText}
              </div>
            )}
          </div>
        </div>
      );
    }

    if (type === 'whatsapp_video') {
      return (
        <div style={{ background: '#e5ddd5', borderRadius: 12, padding: 16, maxWidth: 340 }}>
          <div style={{ background: '#dcf8c6', borderRadius: '0 12px 12px 12px', padding: 0, maxWidth: 300, overflow: 'hidden', boxShadow: '0 1px 2px rgba(0,0,0,0.15)' }}>
            {data.headerText && <div style={{ padding: '10px 14px 4px', fontSize: 13, fontWeight: 700, color: '#222' }}>{data.headerText}</div>}
            <div style={{ background: '#1a1a1a', height: 170, display: 'flex', alignItems: 'center', justifyContent: 'center', margin: data.headerText ? '0 8px' : 0, borderRadius: data.headerText ? 8 : 0, position: 'relative' }}>
              <div style={{ width: 50, height: 50, borderRadius: '50%', background: 'rgba(255,255,255,0.25)', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                <span style={{ fontSize: 28, color: '#fff', marginLeft: 4 }}>▶</span>
              </div>
              {data.videoUrl && <div style={{ position: 'absolute', bottom: 6, left: 10, fontSize: 9, color: '#aaa', maxWidth: '90%', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{data.videoUrl}</div>}
            </div>
            <div style={{ padding: '8px 14px', fontSize: 14, color: '#222', lineHeight: 1.5, whiteSpace: 'pre-wrap' }}>
              {data.messageContent || 'Message...'}
            </div>
            {data.footerText && <div style={{ padding: '0 14px 6px', fontSize: 11, color: '#888' }}>{data.footerText}</div>}
            <div style={{ padding: '0 14px 8px', textAlign: 'right' }}>
              <span style={{ fontSize: 10, color: '#7d9b7e' }}>{new Date().toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })}</span>
              <span style={{ fontSize: 10, color: '#4fc3f7', marginLeft: 4 }}>✓✓</span>
            </div>
            {data.buttonText && (
              <div style={{ borderTop: '1px solid #b6dab8', padding: '10px 14px', textAlign: 'center' }}>
                <span style={{ color: '#039be5', fontSize: 14, fontWeight: 500 }}>🔗 {data.buttonText}</span>
              </div>
            )}
          </div>
          {data.templateName && <div style={{ fontSize: 10, color: '#666', marginTop: 6, textAlign: 'center' }}>Template: {data.templateName}</div>}
        </div>
      );
    }

    if (type === 'whatsapp_document') {
      return (
        <div style={{ background: '#e5ddd5', borderRadius: 12, padding: 16, maxWidth: 340 }}>
          <div style={{ background: '#dcf8c6', borderRadius: '0 12px 12px 12px', padding: 0, maxWidth: 300, overflow: 'hidden', boxShadow: '0 1px 2px rgba(0,0,0,0.15)' }}>
            {data.headerText && <div style={{ padding: '10px 14px 4px', fontSize: 13, fontWeight: 700, color: '#222' }}>{data.headerText}</div>}
            <div style={{ background: '#e8f5e9', margin: 8, borderRadius: 8, padding: 12, display: 'flex', alignItems: 'center', gap: 10 }}>
              <div style={{ width: 40, height: 48, background: '#c62828', borderRadius: 4, display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0 }}>
                <span style={{ color: '#fff', fontSize: 10, fontWeight: 700 }}>PDF</span>
              </div>
              <div style={{ flex: 1, minWidth: 0 }}>
                <div style={{ fontSize: 13, fontWeight: 600, color: '#222', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{data.documentName || 'Document.pdf'}</div>
                <div style={{ fontSize: 10, color: '#888', marginTop: 2 }}>Document • PDF</div>
              </div>
              <FiFile style={{ fontSize: 18, color: '#69a36f', flexShrink: 0 }} />
            </div>
            <div style={{ padding: '8px 14px', fontSize: 14, color: '#222', lineHeight: 1.5, whiteSpace: 'pre-wrap' }}>
              {data.messageContent || 'Message...'}
            </div>
            {data.footerText && <div style={{ padding: '0 14px 6px', fontSize: 11, color: '#888' }}>{data.footerText}</div>}
            <div style={{ padding: '0 14px 8px', textAlign: 'right' }}>
              <span style={{ fontSize: 10, color: '#7d9b7e' }}>{new Date().toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })}</span>
              <span style={{ fontSize: 10, color: '#4fc3f7', marginLeft: 4 }}>✓✓</span>
            </div>
            {data.buttonText && (
              <div style={{ borderTop: '1px solid #b6dab8', padding: '10px 14px', textAlign: 'center' }}>
                <span style={{ color: '#039be5', fontSize: 14, fontWeight: 500 }}>🔗 {data.buttonText}</span>
              </div>
            )}
          </div>
          {data.templateName && <div style={{ fontSize: 10, color: '#666', marginTop: 6, textAlign: 'center' }}>Template: {data.templateName}</div>}
        </div>
      );
    }

    if (type === 'rcs') {
      return (
        <div style={{ background: '#f0f0f0', borderRadius: 16, padding: 16, maxWidth: 340 }}>
          <div style={{ background: '#fff', borderRadius: 16, overflow: 'hidden', boxShadow: '0 2px 8px rgba(0,0,0,0.1)' }}>
            <div style={{ padding: '12px 16px', display: 'flex', alignItems: 'center', gap: 10, borderBottom: '1px solid #eee' }}>
              <div style={{ width: 34, height: 34, borderRadius: '50%', background: 'linear-gradient(135deg, #667eea, #764ba2)', display: 'flex', alignItems: 'center', justifyContent: 'center', color: '#fff', fontSize: 13, fontWeight: 700 }}>
                {(data.senderId || 'B')[0].toUpperCase()}
              </div>
              <div>
                <div style={{ fontSize: 14, fontWeight: 600, color: '#222' }}>{data.senderId || 'Brand'}</div>
                <div style={{ fontSize: 10, color: '#00B4D8' }}>Verified ✓</div>
              </div>
            </div>
            {data.imageUrl && (
              <div style={{ height: 160, background: '#e0e0e0', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                <img src={data.imageUrl} alt="" style={{ width: '100%', height: 160, objectFit: 'cover' }} onError={e => { e.target.style.display = 'none'; }} />
              </div>
            )}
            {data.headerText && <div style={{ padding: '12px 16px 4px', fontSize: 15, fontWeight: 700, color: '#222' }}>{data.headerText}</div>}
            <div style={{ padding: '8px 16px 12px', fontSize: 14, color: '#444', lineHeight: 1.5, whiteSpace: 'pre-wrap' }}>
              {data.messageContent || 'Rich message...'}
            </div>
            {data.buttonText && (
              <div style={{ padding: '0 16px 14px' }}>
                <div style={{ background: '#667eea', color: '#fff', textAlign: 'center', padding: '10px 16px', borderRadius: 24, fontSize: 14, fontWeight: 600, cursor: 'pointer' }}>
                  {data.buttonText}
                </div>
              </div>
            )}
            {data.footerText && <div style={{ padding: '8px 16px 12px', fontSize: 11, color: '#999', borderTop: '1px solid #eee' }}>{data.footerText}</div>}
          </div>
        </div>
      );
    }

    if (type === 'push_notification') {
      return (
        <div style={{ background: '#1a1a2e', borderRadius: 20, padding: 20, maxWidth: 340 }}>
          <div style={{ fontSize: 11, color: '#888', textAlign: 'center', marginBottom: 8 }}>
            {new Date().toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })}
          </div>
          <div style={{ background: 'rgba(255,255,255,0.12)', backdropFilter: 'blur(20px)', borderRadius: 14, padding: 14, display: 'flex', gap: 12, alignItems: 'flex-start' }}>
            <div style={{ width: 36, height: 36, borderRadius: 8, background: cfg.gradient, display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0 }}>
              <FiBell style={{ color: '#fff', fontSize: 16 }} />
            </div>
            <div style={{ flex: 1, minWidth: 0 }}>
              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 4 }}>
                <span style={{ fontSize: 13, fontWeight: 700, color: '#fff' }}>{data.senderId || 'App Name'}</span>
                <span style={{ fontSize: 10, color: '#888' }}>now</span>
              </div>
              <div style={{ fontSize: 14, fontWeight: 600, color: '#eee', marginBottom: 3 }}>{data.notificationTitle || 'Notification Title'}</div>
              <div style={{ fontSize: 13, color: '#bbb', lineHeight: 1.4, display: '-webkit-box', WebkitLineClamp: 3, WebkitBoxOrient: 'vertical', overflow: 'hidden' }}>
                {data.messageContent || 'Notification body...'}
              </div>
              {data.imageUrl && (
                <div style={{ marginTop: 8, height: 100, borderRadius: 8, overflow: 'hidden', background: '#333' }}>
                  <img src={data.imageUrl} alt="" style={{ width: '100%', height: 100, objectFit: 'cover' }} onError={e => { e.target.style.display = 'none'; }} />
                </div>
              )}
              {data.buttonText && (
                <div style={{ marginTop: 8, display: 'flex', gap: 8 }}>
                  <span style={{ fontSize: 12, color: '#4fc3f7', fontWeight: 600 }}>{data.buttonText}</span>
                </div>
              )}
            </div>
          </div>
        </div>
      );
    }

    if (type === 'voice_call') {
      return (
        <div style={{ background: '#1a1a1a', borderRadius: 24, padding: 20, maxWidth: 300, textAlign: 'center' }}>
          <div style={{ width: 70, height: 70, borderRadius: '50%', background: 'linear-gradient(135deg, #00bfa5, #00897b)', margin: '0 auto 14px', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
            <FiPhoneCall style={{ fontSize: 30, color: '#fff' }} />
          </div>
          <div style={{ fontSize: 18, fontWeight: 700, color: '#fff', marginBottom: 4 }}>{data.senderId || 'Caller ID'}</div>
          <div style={{ fontSize: 12, color: '#00B4D8', marginBottom: 16 }}>● Connected</div>
          <div style={{ background: 'rgba(255,255,255,0.08)', borderRadius: 12, padding: 14, marginBottom: 16, textAlign: 'left' }}>
            <div style={{ fontSize: 10, color: '#888', marginBottom: 6, fontWeight: 600, textTransform: 'uppercase', letterSpacing: 1 }}>Voice Script (TTS)</div>
            <div style={{ fontSize: 13, color: '#ddd', lineHeight: 1.6, whiteSpace: 'pre-wrap', fontStyle: 'italic' }}>
              "{data.voiceScript || data.messageContent || 'Hello, this is an automated call...'}"
            </div>
          </div>
          <div style={{ display: 'flex', justifyContent: 'center', gap: 20 }}>
            <div style={{ width: 44, height: 44, borderRadius: '50%', background: '#ef4444', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
              <span style={{ color: '#fff', fontSize: 18 }}>✕</span>
            </div>
            <div style={{ width: 44, height: 44, borderRadius: '50%', background: '#43A047', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
              <FiPhoneCall style={{ color: '#fff', fontSize: 18 }} />
            </div>
          </div>
        </div>
      );
    }

    if (type === 'custom') {
      const fields = data.customFields || {};
      return (
        <div style={{ background: '#f5f5f5', borderRadius: 12, padding: 16, maxWidth: 360 }}>
          <div style={{ background: '#fff', borderRadius: 12, overflow: 'hidden', boxShadow: '0 2px 8px rgba(0,0,0,0.08)' }}>
            <div style={{ background: cfg.gradient, padding: '14px 18px', color: '#fff', display: 'flex', alignItems: 'center', gap: 10 }}>
              <FiSettings style={{ fontSize: 18 }} />
              <div>
                <div style={{ fontSize: 15, fontWeight: 700 }}>Custom Template</div>
                <div style={{ fontSize: 11, opacity: 0.8 }}>{data.senderId || 'Channel'}</div>
              </div>
            </div>
            {data.headerText && <div style={{ padding: '12px 18px 4px', fontSize: 14, fontWeight: 600, color: '#333' }}>{data.headerText}</div>}
            {data.messageContent && (
              <div style={{ padding: '8px 18px', fontSize: 14, color: '#444', lineHeight: 1.5, whiteSpace: 'pre-wrap' }}>
                {data.messageContent}
              </div>
            )}
            {Object.keys(fields).length > 0 && (
              <div style={{ padding: '8px 18px 14px' }}>
                <div style={{ fontSize: 11, fontWeight: 600, color: '#888', marginBottom: 8, textTransform: 'uppercase', letterSpacing: 1 }}>Custom Fields</div>
                {Object.entries(fields).map(([key, val], i) => (
                  <div key={i} style={{ display: 'flex', justifyContent: 'space-between', padding: '6px 0', borderBottom: '1px solid #f0f0f0', fontSize: 13 }}>
                    <span style={{ color: '#666', fontWeight: 500 }}>{key}</span>
                    <span style={{ color: '#222', fontWeight: 600 }}>{val || '—'}</span>
                  </div>
                ))}
              </div>
            )}
            {data.buttonText && (
              <div style={{ padding: '0 18px 14px', textAlign: 'center' }}>
                <span style={{ display: 'inline-block', background: cfg.gradient, color: '#fff', padding: '8px 24px', borderRadius: 20, fontSize: 13, fontWeight: 600 }}>
                  {data.buttonText}
                </span>
              </div>
            )}
            {data.footerText && <div style={{ padding: '10px 18px', borderTop: '1px solid #eee', fontSize: 11, color: '#999', textAlign: 'center' }}>{data.footerText}</div>}
          </div>
        </div>
      );
    }

    return null;
  };

  // ── FIELD RENDERERS ──
  const renderField = (fieldName, value, onChange, config) => {
    const hasField = config?.fields?.includes(fieldName);
    if (!hasField) return null;

    switch (fieldName) {
      case 'senderId':
        return (
          <div className="form-group" key={fieldName}>
            <label className="form-label">{config.senderLabel}</label>
            <div style={{ position: 'relative' }}>
              <input className="form-input" placeholder={config.senderPlaceholder} value={value.senderId}
                onChange={e => onChange({ ...value, senderId: e.target.value })} required
                style={{ paddingLeft: 36 }} />
              <span style={{ position: 'absolute', left: 12, top: '50%', transform: 'translateY(-50%)', color: config.color, fontSize: 16 }}>
                {config.icon}
              </span>
            </div>
          </div>
        );
      case 'templateName':
        return (
          <div className="form-group" key={fieldName}>
            <label className="form-label"><FiFileText style={{ marginRight: 6, verticalAlign: -2 }} />Template Name</label>
            <input className="form-input" placeholder="e.g. order_confirmation" value={value.templateName || ''}
              onChange={e => onChange({ ...value, templateName: e.target.value })} />
          </div>
        );
      case 'subject':
        return (
          <div className="form-group" key={fieldName}>
            <label className="form-label"><FiType style={{ marginRight: 6, verticalAlign: -2 }} />Subject Line</label>
            <input className="form-input" placeholder="Enter email subject..." value={value.subject || ''}
              onChange={e => onChange({ ...value, subject: e.target.value })} required />
          </div>
        );
      case 'headerText':
        return (
          <div className="form-group" key={fieldName}>
            <label className="form-label">Header Text</label>
            <input className="form-input" placeholder="Header / Title text" value={value.headerText || ''}
              onChange={e => onChange({ ...value, headerText: e.target.value })} />
          </div>
        );
      case 'imageUrl':
        return (
          <div className="form-group" key={fieldName}>
            <label className="form-label"><FiImage style={{ marginRight: 6, verticalAlign: -2 }} />Image URL</label>
            <input className="form-input" placeholder="https://example.com/image.jpg" value={value.imageUrl || ''}
              onChange={e => onChange({ ...value, imageUrl: e.target.value })} />
            {value.imageUrl && (
              <div style={{ marginTop: 8, borderRadius: 8, overflow: 'hidden', maxHeight: 120 }}>
                <img src={value.imageUrl} alt="preview" style={{ width: '100%', maxHeight: 120, objectFit: 'cover' }}
                  onError={e => { e.target.style.display = 'none'; }} />
              </div>
            )}
          </div>
        );
      case 'messageContent':
        return (
          <div className="form-group" key={fieldName}>
            <label className="form-label">
              Message Content
              {config.maxChars && <span style={{ float: 'right', fontSize: 11, color: (value.messageContent?.length || 0) > config.maxChars ? '#ef4444' : '#999' }}>
                {(value.messageContent?.length || 0).toLocaleString()} / {config.maxChars.toLocaleString()}
              </span>}
            </label>
            <textarea className="form-textarea" placeholder={config.messagePlaceholder} value={value.messageContent || ''}
              onChange={e => onChange({ ...value, messageContent: e.target.value })} required
              style={{ minHeight: config.preview === 'newsletter' ? 120 : 80 }} />
          </div>
        );
      case 'footerText':
        return (
          <div className="form-group" key={fieldName}>
            <label className="form-label">Footer Text <span style={{ fontSize: 11, color: '#999' }}>(optional)</span></label>
            <input className="form-input" placeholder="e.g. Reply STOP to unsubscribe" value={value.footerText || ''}
              onChange={e => onChange({ ...value, footerText: e.target.value })} />
          </div>
        );
      case 'buttonText':
        return (
          <div key={fieldName} style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 12 }}>
            <div className="form-group">
              <label className="form-label"><FiLink style={{ marginRight: 6, verticalAlign: -2 }} />Button Text</label>
              <input className="form-input" placeholder="e.g. Visit Website" value={value.buttonText || ''}
                onChange={e => onChange({ ...value, buttonText: e.target.value })} />
            </div>
            <div className="form-group">
              <label className="form-label">Button URL</label>
              <input className="form-input" placeholder="https://..." value={value.buttonUrl || ''}
                onChange={e => onChange({ ...value, buttonUrl: e.target.value })} />
            </div>
          </div>
        );
      case 'videoUrl':
        return (
          <div className="form-group" key={fieldName}>
            <label className="form-label"><FiVideo style={{ marginRight: 6, verticalAlign: -2 }} />Video URL</label>
            <input className="form-input" placeholder="https://example.com/video.mp4" value={value.videoUrl || ''}
              onChange={e => onChange({ ...value, videoUrl: e.target.value })} />
          </div>
        );
      case 'documentUrl':
        return (
          <div key={fieldName} style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 12 }}>
            <div className="form-group">
              <label className="form-label"><FiFile style={{ marginRight: 6, verticalAlign: -2 }} />Document URL</label>
              <input className="form-input" placeholder="https://example.com/doc.pdf" value={value.documentUrl || ''}
                onChange={e => onChange({ ...value, documentUrl: e.target.value })} />
            </div>
            <div className="form-group">
              <label className="form-label">Document Name</label>
              <input className="form-input" placeholder="e.g. Invoice.pdf" value={value.documentName || ''}
                onChange={e => onChange({ ...value, documentName: e.target.value })} />
            </div>
          </div>
        );
      case 'documentName':
        return null; // handled inside documentUrl case
      case 'notificationTitle':
        return (
          <div className="form-group" key={fieldName}>
            <label className="form-label"><FiBell style={{ marginRight: 6, verticalAlign: -2 }} />Notification Title</label>
            <input className="form-input" placeholder="e.g. You have a new offer!" value={value.notificationTitle || ''}
              onChange={e => onChange({ ...value, notificationTitle: e.target.value })} required />
          </div>
        );
      case 'voiceScript':
        return (
          <div className="form-group" key={fieldName}>
            <label className="form-label"><FiPhoneCall style={{ marginRight: 6, verticalAlign: -2 }} />Voice Script (TTS)</label>
            <textarea className="form-textarea" placeholder="Enter the text-to-speech script that will be read to the caller..." value={value.voiceScript || ''}
              onChange={e => onChange({ ...value, voiceScript: e.target.value })} required
              style={{ minHeight: 100 }} />
          </div>
        );
      case 'customFields':
        return (
          <div className="form-group" key={fieldName}>
            <label className="form-label" style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
              <span><FiSettings style={{ marginRight: 6, verticalAlign: -2 }} />Custom Fields</span>
              <button type="button" className="btn btn-secondary" style={{ padding: '3px 10px', fontSize: 11 }}
                onClick={() => {
                  const fields = { ...(value.customFields || {}) };
                  fields[`field_${Object.keys(fields).length + 1}`] = '';
                  onChange({ ...value, customFields: fields });
                }}>
                <FiPlus style={{ marginRight: 4, verticalAlign: -2 }} />Add Field
              </button>
            </label>
            {Object.entries(value.customFields || {}).map(([key, val], idx) => (
              <div key={idx} style={{ display: 'grid', gridTemplateColumns: '1fr 1fr auto', gap: 8, marginBottom: 8 }}>
                <input className="form-input" placeholder="Field Name" value={key}
                  onChange={e => {
                    const fields = { ...(value.customFields || {}) };
                    const oldVal = fields[key];
                    delete fields[key];
                    fields[e.target.value] = oldVal;
                    onChange({ ...value, customFields: fields });
                  }} />
                <input className="form-input" placeholder="Field Value" value={val}
                  onChange={e => {
                    const fields = { ...(value.customFields || {}) };
                    fields[key] = e.target.value;
                    onChange({ ...value, customFields: fields });
                  }} />
                <button type="button" style={{ background: 'none', border: 'none', color: '#ef4444', cursor: 'pointer', padding: 6, fontSize: 16 }}
                  onClick={() => {
                    const fields = { ...(value.customFields || {}) };
                    delete fields[key];
                    onChange({ ...value, customFields: fields });
                  }}>
                  <FiTrash2 />
                </button>
              </div>
            ))}
          </div>
        );
      default:
        return null;
    }
  };

  if (loading) return <div className="loading-spinner"><div className="spinner" /></div>;

  return (
    <div>
      <div className="page-header">
        <div>
          <h1 className="page-title">Message Schedules</h1>
          <p className="page-subtitle">Manage delivery schedules</p>
        </div>
        <button className="btn btn-primary" onClick={() => setShowCreate(true)}>+ Create Schedule</button>
      </div>

      {grouped.length === 0 ? (
        <div className="card"><div className="empty-state"><h3>No schedules yet</h3><p>Create a schedule to get started</p></div></div>
      ) : grouped.map((group, gi) => {
        const gType = group.campaign?.type || 'sms';
        const gCfg = TYPE_CONFIG[gType] || TYPE_CONFIG.sms;
        return (
          <div key={gi} className="card" style={{ marginBottom: 20 }}>
            <div className="card-header" style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
              <h3 className="card-title" style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
                <span style={{ color: gCfg.color, fontSize: 20 }}>{gCfg.icon}</span>
                {group.campaign?.name || 'Unknown Campaign'}
                {' '}<span className="badge" style={{ background: gCfg.color, color: '#fff' }}>{gCfg.label}</span>
              </h3>
            </div>

            {group.schedules.map(sched => (
              <div key={sched._id} style={{ background: 'var(--bg-glass)', border: '1px solid var(--border-color)', borderRadius: 'var(--radius-md)', padding: 16, marginBottom: 12 }}>
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', marginBottom: 12 }}>
                  <div style={{ flex: 1 }}>
                    <div style={{ display: 'flex', gap: 16, flexWrap: 'wrap', alignItems: 'center', marginBottom: 8 }}>
                      <span style={{ fontSize: 13, color: 'var(--text-muted)' }}>Sender: <span style={{ color: gCfg.color, fontWeight: 600 }}>{sched.senderId}</span></span>
                      {sched.templateName && <span style={{ fontSize: 12, color: '#999', background: 'var(--bg-card)', padding: '2px 8px', borderRadius: 4 }}>📄 {sched.templateName}</span>}
                      {sched.subject && <span style={{ fontSize: 12, color: '#999' }}>Subject: <strong>{sched.subject}</strong></span>}
                    </div>
                    <div style={{ fontSize: 13, color: 'var(--text-secondary)', maxWidth: 500 }}>
                      {sched.messageContent?.substring(0, 120)}{sched.messageContent?.length > 120 ? '...' : ''}
                    </div>
                    {sched.imageUrl && <div style={{ fontSize: 12, color: gCfg.color, marginTop: 4 }}>🖼️ Image attached</div>}
                    {sched.buttonText && <div style={{ fontSize: 12, color: '#039be5', marginTop: 4 }}>🔗 {sched.buttonText}</div>}
                  </div>
                  <div className="actions" style={{ display: 'flex', gap: 6 }}>
                    <button className="action-btn" style={{ color: gCfg.color }}
                      onClick={() => setShowPreview({ type: gType, data: sched })}>Preview</button>
                    <button className="action-btn edit" onClick={() => {
                      setShowEdit(sched);
                      setEditForm({
                        senderId: sched.senderId || '', messageContent: sched.messageContent || '',
                        subject: sched.subject || '', headerText: sched.headerText || '',
                        footerText: sched.footerText || '', buttonText: sched.buttonText || '',
                        buttonUrl: sched.buttonUrl || '', imageUrl: sched.imageUrl || '',
                        templateName: sched.templateName || '', ctaType: sched.ctaType || ''
                      });
                    }}>Edit</button>
                    <button className="action-btn delete" onClick={() => handleDelete(sched._id)}>Delete</button>
                  </div>
                </div>

                <div className="table-container">
                  <table className="data-table">
                    <thead>
                      <tr><th>Batch</th><th>Size</th><th>Scheduled For</th><th>Sent At</th><th>Status</th><th>Actions</th></tr>
                    </thead>
                    <tbody>
                      {sched.batches?.map(batch => {
                        const isEditingScheduled = editingDate?.batchId === batch._id && editingDate?.field === 'scheduledFor';
                        const isEditingSentAt = editingDate?.batchId === batch._id && editingDate?.field === 'sentAt';
                        const toLocalInput = (d) => {
                          const dt = new Date(d);
                          return new Date(dt.getTime() - dt.getTimezoneOffset() * 60000).toISOString().slice(0, 16);
                        };
                        return (
                        <tr key={batch._id}>
                          <td style={{ fontWeight: 600, color: 'var(--text-primary)' }}>#{batch.batchNumber}</td>
                          <td>{batch.batchSize}</td>
                          <td>
                            {isEditingScheduled ? (
                              <div style={{ display: 'flex', alignItems: 'center', gap: 4 }}>
                                <input type="datetime-local" className="form-input"
                                  style={{ width: 200, padding: '4px 8px', fontSize: 12 }}
                                  value={editingDate.value}
                                  onChange={e => setEditingDate({ ...editingDate, value: e.target.value })} />
                                <button className="btn btn-primary" style={{ padding: '4px 10px', fontSize: 11, minWidth: 'auto' }}
                                  onClick={() => handleBatchDateUpdate(batch._id)}>✓</button>
                                <button className="btn btn-secondary" style={{ padding: '4px 10px', fontSize: 11, minWidth: 'auto' }}
                                  onClick={() => setEditingDate(null)}>✕</button>
                              </div>
                            ) : (
                              <span style={{ cursor: 'pointer', borderBottom: '1px dashed #999' }}
                                title="Click to edit schedule date"
                                onClick={() => setEditingDate({ batchId: batch._id, field: 'scheduledFor', value: toLocalInput(batch.scheduledFor) })}>
                                {new Date(batch.scheduledFor).toLocaleString()}
                              </span>
                            )}
                          </td>
                          <td>
                            {isEditingSentAt ? (
                              <div style={{ display: 'flex', alignItems: 'center', gap: 4 }}>
                                <input type="datetime-local" className="form-input"
                                  style={{ width: 200, padding: '4px 8px', fontSize: 12 }}
                                  value={editingDate.value}
                                  onChange={e => setEditingDate({ ...editingDate, value: e.target.value })} />
                                <button className="btn btn-primary" style={{ padding: '4px 10px', fontSize: 11, minWidth: 'auto' }}
                                  onClick={() => handleBatchDateUpdate(batch._id)}>✓</button>
                                <button className="btn btn-secondary" style={{ padding: '4px 10px', fontSize: 11, minWidth: 'auto' }}
                                  onClick={() => setEditingDate(null)}>✕</button>
                              </div>
                            ) : batch.sentAt ? (
                              <span style={{ cursor: 'pointer', borderBottom: '1px dashed #999' }}
                                title="Click to edit sent date"
                                onClick={() => setEditingDate({ batchId: batch._id, field: 'sentAt', value: toLocalInput(batch.sentAt) })}>
                                {new Date(batch.scheduledFor || batch.sentAt).toLocaleString()}
                              </span>
                            ) : (
                              <span style={{ color: '#999' }}>—</span>
                            )}
                          </td>
                          <td><span className={`badge badge-${batch.status}`}>{batch.status}</span></td>
                          <td>
                            <select value={batch.status} onChange={e => handleBatchStatus(batch._id, e.target.value)}
                              className="form-select" style={{ width: 'auto', padding: '4px 8px', fontSize: 12 }}>
                              <option value="pending">Pending</option>
                              <option value="processing">Processing</option>
                              <option value="sent">Sent</option>
                            </select>
                          </td>
                        </tr>
                        );
                      })}
                    </tbody>
                  </table>
                </div>
              </div>
            ))}
          </div>
        );
      })}

      {/* ════════════ CREATE MODAL ════════════ */}
      {showCreate && (
        <div className="modal-overlay" onClick={() => setShowCreate(false)}>
          <div className="modal" onClick={e => e.stopPropagation()} style={{ maxWidth: typeConfig ? 820 : 560 }}>
            <div className="modal-header" style={{ background: typeConfig ? typeConfig.gradient : undefined, color: typeConfig ? '#fff' : undefined }}>
              <h2 style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
                {typeConfig && <span style={{ fontSize: 22 }}>{typeConfig.icon}</span>}
                Create {typeConfig ? typeConfig.label + ' ' : ''}Schedule
              </h2>
              <button className="modal-close" onClick={() => setShowCreate(false)} style={typeConfig ? { color: '#fff' } : undefined}>×</button>
            </div>
            <form onSubmit={handleCreate}>
              <div className="modal-body">
                <div style={{ display: typeConfig ? 'grid' : 'block', gridTemplateColumns: '1fr 340px', gap: 24 }}>
                  {/* LEFT: Fields */}
                  <div>
                    {/* Campaign Selector */}
                    <div className="form-group">
                      <label className="form-label">Campaign</label>
                      <select className="form-select" value={form.campaignId}
                        onChange={e => setForm({ ...defaultForm, campaignId: e.target.value })} required>
                        <option value="">Select Campaign</option>
                        {campaigns.map(c => {
                          const tc = TYPE_CONFIG[c.type];
                          return (
                            <option key={c._id} value={c._id}>
                              {tc ? tc.label + ' • ' : ''}{c.name} — {(c.assignedData || 0).toLocaleString()} records
                            </option>
                          );
                        })}
                      </select>
                      {selectedCampaign && (
                        <div style={{ marginTop: 8, padding: '10px 14px', background: `${typeConfig?.color}10`, borderRadius: 8, fontSize: 13, borderLeft: `3px solid ${typeConfig?.color}` }}>
                          <div style={{ display: 'flex', gap: 16, flexWrap: 'wrap' }}>
                            <span><strong style={{ color: '#00B4D8' }}>{(selectedCampaign.assignedData || 0).toLocaleString()}</strong> Total</span>
                            <span><strong style={{ color: '#22c55e' }}>{(selectedCampaign.sentCount || 0).toLocaleString()}</strong> Sent</span>
                            <span><strong style={{ color: '#ef4444' }}>{(selectedCampaign.failedCount || 0).toLocaleString()}</strong> Failed</span>
                            <span><strong style={{ color: '#f97316' }}>{(selectedCampaign.pendingCount || 0).toLocaleString()}</strong> Pending</span>
                          </div>
                        </div>
                      )}
                    </div>

                    {/* Dynamic Fields */}
                    {typeConfig && (
                      <>
                        {typeConfig.fields.map(f => {
                          if (f === 'buttonUrl') return null;
                          return renderField(f, form, setForm, typeConfig);
                        })}
                      </>
                    )}

                    {/* Batches */}
                    {typeConfig && (
                      <div className="form-group">
                        <label className="form-label">Number of Deliveries (Batches)</label>
                        <input type="number" className="form-input" min="1" value={form.totalDeliveries}
                          onChange={e => setForm({ ...form, totalDeliveries: e.target.value === '' ? '' : (parseInt(e.target.value) || 1) })} />
                      </div>
                    )}
                  </div>

                  {/* RIGHT: Live Preview */}
                  {typeConfig && (
                    <div>
                      <div style={{ fontSize: 12, fontWeight: 600, color: '#999', textTransform: 'uppercase', letterSpacing: 1, marginBottom: 10 }}>
                        Live Preview
                      </div>
                      <div style={{ position: 'sticky', top: 0 }}>
                        {renderMessagePreview(campaignType, form)}
                      </div>
                    </div>
                  )}
                </div>
              </div>
              <div className="modal-footer">
                <button type="button" className="btn btn-secondary" onClick={() => setShowCreate(false)}>Cancel</button>
                <button type="submit" className="btn btn-primary" style={typeConfig ? { background: typeConfig.gradient, border: 'none' } : undefined}>
                  Create Schedule
                </button>
              </div>
            </form>
          </div>
        </div>
      )}

      {/* ════════════ EDIT MODAL ════════════ */}
      {showEdit && (
        <div className="modal-overlay" onClick={() => setShowEdit(null)}>
          <div className="modal" onClick={e => e.stopPropagation()} style={{ maxWidth: editTypeConfig ? 820 : 560 }}>
            <div className="modal-header" style={{ background: editTypeConfig ? editTypeConfig.gradient : undefined, color: editTypeConfig ? '#fff' : undefined }}>
              <h2 style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
                {editTypeConfig && <span style={{ fontSize: 22 }}>{editTypeConfig.icon}</span>}
                Edit {editTypeConfig ? editTypeConfig.label + ' ' : ''}Schedule
              </h2>
              <button className="modal-close" onClick={() => setShowEdit(null)} style={editTypeConfig ? { color: '#fff' } : undefined}>×</button>
            </div>
            <form onSubmit={handleEdit}>
              <div className="modal-body">
                <div style={{ display: editTypeConfig ? 'grid' : 'block', gridTemplateColumns: '1fr 340px', gap: 24 }}>
                  <div>
                    {editTypeConfig ? (
                      editTypeConfig.fields.map(f => {
                        if (f === 'buttonUrl') return null;
                        return renderField(f, editForm, setEditForm, editTypeConfig);
                      })
                    ) : (
                      <>
                        <div className="form-group">
                          <label className="form-label">Sender ID</label>
                          <input className="form-input" value={editForm.senderId}
                            onChange={e => setEditForm({ ...editForm, senderId: e.target.value })} required />
                        </div>
                        <div className="form-group">
                          <label className="form-label">Message Content</label>
                          <textarea className="form-textarea" value={editForm.messageContent}
                            onChange={e => setEditForm({ ...editForm, messageContent: e.target.value })} required />
                        </div>
                      </>
                    )}
                  </div>
                  {editTypeConfig && (
                    <div>
                      <div style={{ fontSize: 12, fontWeight: 600, color: '#999', textTransform: 'uppercase', letterSpacing: 1, marginBottom: 10 }}>
                        Live Preview
                      </div>
                      {renderMessagePreview(editCampaignType, editForm)}
                    </div>
                  )}
                </div>
              </div>
              <div className="modal-footer">
                <button type="button" className="btn btn-secondary" onClick={() => setShowEdit(null)}>Cancel</button>
                <button type="submit" className="btn btn-primary" style={editTypeConfig ? { background: editTypeConfig.gradient, border: 'none' } : undefined}>
                  Update
                </button>
              </div>
            </form>
          </div>
        </div>
      )}

      {/* ════════════ PREVIEW MODAL ════════════ */}
      {showPreview && (
        <div className="modal-overlay" onClick={() => setShowPreview(null)}>
          <div className="modal" onClick={e => e.stopPropagation()} style={{ maxWidth: 480, background: 'transparent', boxShadow: 'none' }}>
            <div style={{ display: 'flex', justifyContent: 'flex-end', marginBottom: 8 }}>
              <button onClick={() => setShowPreview(null)}
                style={{ background: 'rgba(0,0,0,0.5)', color: '#fff', borderRadius: '50%', width: 32, height: 32, display: 'flex', alignItems: 'center', justifyContent: 'center', border: 'none', cursor: 'pointer', fontSize: 18 }}>×</button>
            </div>
            <div style={{ display: 'flex', justifyContent: 'center' }}>
              {renderMessagePreview(showPreview.type, showPreview.data)}
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
